module.exports = __webpack_public_path__ + "img/jan-roedger.f0af7163.jpg";